module.exports = __webpack_public_path__ + "static/media/passcheckScreenshot.b2815b7a.png";